import React from "react";

const HoverImagePreview = ({ imageUrl, size = 40 }) => {
  const [hover, setHover] = React.useState(false);

  if (!imageUrl) return null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <img
        src={imageUrl}
        alt="preview"
        width={size}
        height={size}
        style={{
          cursor: "pointer",
          borderRadius: "4px",
          border: "1px solid #ccc",
          display: "flex",
          margin: "0 auto",
          background: "#fff",
        }}
      />
      {hover && (
        <div
          style={{
            position: "fixed",
            marginTop: size + 6,
            left: "85%",
            transform: "translateX(-50%)",
            zIndex: 999999,
            background: "transparent",
            boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            pointerEvents: "none",
          }}
        >
          <img
            src={imageUrl}
            alt="large preview"
            style={{
              maxWidth: "360px",
              maxHeight: "360px",
              borderRadius: "4px",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default HoverImagePreview;